import { render, staticRenderFns } from "./WidgetSettingImage.vue?vue&type=template&id=18d3f774&scoped=true&"
import script from "./WidgetSettingImage.vue?vue&type=script&lang=js&"
export * from "./WidgetSettingImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d3f774",
  null
  
)

export default component.exports